import { DeviceEnabledType, enumerable, NodeEdgeMapper, UserAttributeDefs } from '@iotv/datamodel-core'
import { getEnumShape, Milliseconds, Position, ValidBusinessObject } from '@iotv/iotv-v3-types'
import { FullReported } from '../types'
import { default_solenoid_voltage, IrrStatusTypes } from './Irrigator'
import { updateEntity } from './Irrigator/updateEntity'

const typeName = 'MasterValve'
const OFFLINETHRESHOLDMS = Milliseconds.DAY

enum MasterValveOnlyState {
  OPEN = 'Open',
  CLOSED = 'Closed',
}

export enum MasterValveState {
  ONLINE = IrrStatusTypes.ONLINE,
  OFFLINE = IrrStatusTypes.OFFLINE,
  ERROR = IrrStatusTypes.ERROR,
  IRRIGATING = IrrStatusTypes.IRRIGATING,
  UNSEEN = IrrStatusTypes.UNSEEN,
  DISABLED = IrrStatusTypes.DISABLED,
  AREAPAUSED = IrrStatusTypes.AREAPAUSED,
  AWAITINGPROGRAMME = IrrStatusTypes.AWAITINGPROGRAMME,
  OPEN = MasterValveOnlyState.OPEN,
  CLOSED = MasterValveOnlyState.CLOSED,
}

export type MasterValveProps = {
  location?: Position
  image?: string
  state?: MasterValveState
  currentProgramme?: string
  incomingProgramme?: string
  programUpdatedAt?: number
  comments?: string
  // solenoidModel?: SolenoidTypes
  solenoidVoltage?: number
  /** Programme the MVC is associated to */
  associatedProgramme?: string
  desiredVoltage?: number
  mvcTimePadding: number
}

export class MasterValve extends DeviceEnabledType implements MasterValveProps {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
    this.state = ob.state
    this.updateFromDeviceMessage = updateEntity.bind(this)
    this.calcStatus = ob ? this.getStatus(ob) : undefined
    this.timestamp = Date.now()
    this.solenoidVoltage = ob.solenoidVoltage
    this.solenoidVoltageEUI = ob.solenoidVoltageEUI
    this.desiredVoltage = ob.desiredVoltage ?? default_solenoid_voltage
    this.mvcTimePadding = ob.mvcTimePadding ?? 0
  }

  // state?: string;
  location?: Position
  image?: string
  state: MasterValveState
  timestamp: number
  updated_at?: number
  rssi?: number
  snr?: number
  associatedProgramme?: string
  firmwareVersion?: number

  // solenoidModel?: SolenoidTypes
  solenoidVoltage?: number
  solenoidVoltageEUI?: string
  desiredVoltage?: number

  mvcTimePadding: number

  @enumerable(false)
  updateFromDeviceMessage: (payload: Partial<FullReported>) => void

  getStatus = (valve: ValidBusinessObject = this, mapper: NodeEdgeMapper<ValidBusinessObject> | undefined = this.nodeEdgeMapper) => {
    const status: MasterValveState[] = []
    const now = new Date()
    const lastSeen = new Date(valve.timestamp)
    if (isNaN(lastSeen?.getTime())) {
      status.push(MasterValveState.UNSEEN)
    }
    if (lastSeen?.getTime() < now.getTime() - OFFLINETHRESHOLDMS) {
      status.push(MasterValveState.OFFLINE)
    }
    if (valve.pause) {
      status.push(MasterValveState.AREAPAUSED)
    }
    if (valve.disabled) {
      status.push(MasterValveState.DISABLED)
    }
    if (valve.error && valve.error.length > 0) {
      status.push(MasterValveState.ERROR)
    }
    if (valve.operating) {
      status.push(MasterValveState.IRRIGATING)
    }

    const parentPaddock = mapper && (mapper.getAdjacentNodes(valve, { objectTypeId: 'Area' })[0] as any)
    if (parentPaddock?.pause === true) {
      status.push(MasterValveState.AREAPAUSED)
    }
    if (valve.incomingProgramme !== undefined && !(status.includes(MasterValveState.DISABLED) || status.includes(MasterValveState.AREAPAUSED))) {
      status.push(MasterValveState.AWAITINGPROGRAMME)
    }

    if (status.length === 0) {
      status.push(MasterValveState.ONLINE)
    }

    return status
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of Master Valve',
      },
      // state: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Name',
      //   name: 'name',
      //   description: 'Name of Master Valve',
      // },
      // location: {
      //   type: 'object',
      //   editable: true,
      //   label: 'Location',
      //   name: 'location',
      //   description: 'Location of  Master Valve (lat/ long)',
      // },
      // image: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Image',
      //   name: 'image',
      //   description: 'Photograph of Master Valve',
      // },
      // currentProgramme: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Current Programme',
      //   name: 'currentProgramme',
      //   description: 'Currently running programme',
      // },
      // incomingProgramme: {
      //   type: 'String',
      //   editable: true,
      //   label: 'Incoming Programme',
      //   name: 'incomingProgramme',
      //   description: 'Next programme to be run',
      // },
      // solenoidModel: {
      //   type: 'Enum',
      //   enumKv: getEnumShape(SolenoidOptions),
      //   editable: true,
      //   label: 'Solenoid Model',
      //   name: 'Solenoid Model',
      // },
      mvcTimePadding: {
        type: 'Number',
        editable: true,
        label: 'MVC Time Padding (m)',
        name: 'MVC Time Padding (m)',
      },
      comments: {
        type: 'String',
        editable: true,
        label: 'Comments',
        name: 'comments',
        description: 'Free text for info ',
      },
    }
  }
}
